webpackJsonp([5],{

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e61ea444",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(397);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var KnowledgeDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(501));

var instance = void 0;

var knowledgeDlg = function knowledgeDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new KnowledgeDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.guid = options.guid;
  instance.vm.isEditData = options.isEditData;
  instance.vm.loadData();
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (knowledgeDlg);

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_quill_table__ = __webpack_require__(59);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      isEditData: false,
      kInfo1: {
        guid: '',
        title: '',
        type: '',
        content: '',
        author2Guid: '',
        description: '',
        keyword2: ''
      },
      quill: null,
      toolbarOptions: [[{ 'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5'] }], [{ 'table': 'append-row' }], [{ 'table': 'append-col' }], [{ 'table': 'remove-row' }], [{ 'table': 'remove-col' }], [{ 'table': 'remove-table' }], [{ 'table': 'cell-background' }], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['link', 'image'], ['formula', 'clean', 'video']]
    };
  },

  computed: {
    title: function title() {
      return '\u7F16\u8F91\u77E5\u8BC6\u70B9-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        if (!_this.quill) {
          _this.quill = new window.Quill('#editor', {
            modules: {
              formula: true,
              syntax: true,
              toolbar: {
                container: _this.toolbarOptions,
                handlers: {
                  image: _this.imageHandler
                }
              }
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_quill_table__["setEditor"])(_this.quill);
          if (_this.isEditData === true) {
            _this.loadData();
          }
        }
      }, 1000);
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '知识点',
        message: msg,
        type: type
      });
    },
    weixin: function weixin() {
      var d = {};
      d.mch_id = 'wx9e060fd2c6b37704';
      d.nonce_str = 'thiskInfo1content';
      d.sign = 'EdfO0uMgB41qSxy1WckKcVuOGdfhZc6JnMGMU3pbIF2';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["c" /* weixintest */])(d).then(function (res) {
        if (res) {
          console.log('wei xin res1=' + res);
        } else {
          console.log('wei xin res2=' + res);
        }
      }).catch(function (err) {
        console.log('wei xin err=' + err);
      });
    },
    saveKnowledge: function saveKnowledge() {
      var _this2 = this;

      console.log('保存知识点 this.kInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.kInfo1));
      this.kInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      if (this.isEditData === true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["d" /* updateKnowledgeByGuid */])(this.kInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('修改知识点成功。', 'info');
            } else {
              _this2.showMsg('修改知识点失败。', 'info');
            }
          } else {
            _this2.showMsg('修改知识点不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u4FEE\u6539\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["e" /* addNewKnowledge */])(this.kInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('添加知识点成功。', 'info');
            } else {
              _this2.showMsg('添加知识点失败。', 'info');
            }
          } else {
            _this2.showMsg('添加知识点不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u6DFB\u52A0\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
        });
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      console.log('knowledge--load data,guid=' + this.guid);
      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["f" /* getKnowledgeByGuid */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this3.kInfo1 = data.data[0];
            var tk = JSON.parse(_this3.kInfo1.content);
            console.log(tk.ops);
            if (_this3.quill) {
              _this3.quill.setContents(tk.ops);
              _this3.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this3.showMsg('获取知识点失败，请关闭修改对话框后重新再试！');
          }
          _this3.loading = false;
        }).catch(function (err) {
          _this3.showMsg(err);
          _this3.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_knowledgeDlg__ = __webpack_require__(337);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'guid',
        label: 'guid',
        width: 150
      }, {
        prop: 'title',
        label: '标题',
        width: 280
      }, {
        prop: 'type',
        label: '类型',
        width: 80
      }, {
        prop: 'date',
        label: '日期',
        width: 100
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    edit: function edit(guid) {
      console.log('knowledgeDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_knowledgeDlg__["a" /* default */])({
        isEditData: true,
        guid: guid
      });
    }
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"knowledgeTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("281cf108", content, true);

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("9bbb07e8", content, true);

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "kInfo1",
    attrs: {
      "model": _vm.kInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid"
    },
    model: {
      value: (_vm.kInfo1.guid),
      callback: function($$v) {
        _vm.kInfo1.guid = $$v
      },
      expression: "kInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题,60字以内"
    },
    model: {
      value: (_vm.kInfo1.title),
      callback: function($$v) {
        _vm.kInfo1.title = $$v
      },
      expression: "kInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "类型,60字以内"
    },
    model: {
      value: (_vm.kInfo1.type),
      callback: function($$v) {
        _vm.kInfo1.type = $$v
      },
      expression: "kInfo1.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原作者GUID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者GUID,如果没有，需填入0"
    },
    model: {
      value: (_vm.kInfo1.author2Guid),
      callback: function($$v) {
        _vm.kInfo1.author2Guid = $$v
      },
      expression: "kInfo1.author2Guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.keyword2),
      callback: function($$v) {
        _vm.kInfo1.keyword2 = $$v
      },
      expression: "kInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.description),
      callback: function($$v) {
        _vm.kInfo1.description = $$v
      },
      expression: "kInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveKnowledge
    }
  }, [_vm._v("保存知识点")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("知识点内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container_zsd"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 200px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_knowledgeDlg__ = __webpack_require__(337);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        keywords: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['knowledgeList'])),
  created: function created() {
    this.$store.dispatch('actions_getKnowledgeList', this.form.keywords);
  },

  components: {
    knowledgeTable: __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable___default.a
  },
  methods: {
    searchKnowledge: function searchKnowledge() {
      this.$store.dispatch('actions_getKnowledgeList', this.form.keywords);
    },
    searchKnowledgeAll: function searchKnowledgeAll() {
      this.form = {
        keywords: ''
      };
      this.searchKnowledge();
    },
    addKnowledge: function addKnowledge() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_knowledgeDlg__["a" /* default */])({
        isEditData: false
      });
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".ctitle[data-v-e61ea444]{height:56px;width:100%;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/knowledgeList.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB","file":"knowledgeList.vue","sourcesContent":["\n.ctitle[data-v-e61ea444]{\n  height: 56px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("30d48564", content, true);

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
    on: {
      "click": _vm.addKnowledge
    }
  }, [_vm._v("新增知识点1")])], 1), _vm._v(" "), _c('div', {
    ref: "searchDiv"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "text-align": "left",
      "padding-top": "20px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "关键词",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.form.keywords = $$v
      },
      expression: "form.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchKnowledge
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.searchKnowledgeAll
    }
  }, [_vm._v("全部")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('knowledge-table', {
    attrs: {
      "tableData": _vm.knowledgeList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("知识点列表")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.48592d0df15649a2a530.js